<template>
    <div>
        <b-card no-body class="mb-1">
            <b-overlay :show="loading" opacity="0.2">
                <div class="row p-1">
                    <div class="col-md-3 mb-1 mb-md-0">
                        <b-input-group class="input-group-merge v-table-search-input">
                            <template #prepend>
                                <b-input-group-text >
                                    <feather-icon icon="SearchIcon"></feather-icon>
                                </b-input-group-text>
                            </template>
                            <b-form-input v-model="searchValue" placeholder="Ara..." ></b-form-input>
                        </b-input-group>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-success" v-on:click="getData">Sorgula</button>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0 ml-auto">
                        <b-dropdown :disabled="!excelPath" text="İşlemler" right variant="primary">
                            <b-dropdown-item v-if="excelPath" v-on:click="downloadExcel">
                                <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                Excel İndir
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-sm bordered-header mb-1">
                        <thead>
                            <tr>
                                <th class="py-05">Yaka</th>
                                <th class="py-05">Personel</th>
                                <th class="py-05 text-nowrap">Kimlik Numarası</th>
                                <th class="py-05 text-nowrap">İcra Ofisi</th>
                                <th class="py-05 text-nowrap">Dosya Numarası</th>
                                <th class="py-05">IBAN</th>
                                <th class="py-05 text-nowrap text-right">Tutar (TL)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d,i) in c_items">
                                <td class="text-nowrap">{{ $safe(d,'CollarStatusName') || '-' }}</td>
                                <td class="text-nowrap">{{ $safe(d,'EmployeeFullName') || '-' }}</td>
                                <td class="text-nowrap">{{ $safe(d,'EmployeeIdentityNumber') || '-' }}</td>
                                <td class="text-nowrap">{{ $safe(d,'LevyOfficeName') || '-' }}</td>
                                <td class="text-nowrap">{{ $safe(d,'FileNumber') || '-' }}</td>
                                <td class="text-nowrap">{{ $safe(d,'IBAN') || '-' }}</td>
                                <td class="text-right text-nowrap">{{ $safe(d,'AmountStr') || '-' }}</td>
                            </tr>
                            <template v-if="!total">
                                <tr>
                                    <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="mx-75 my-1" v-if="total > 0">
                    <div class="row justify-content-md-between justify-content-center">
                        <div class="col-auto mb-1 mb-md-0">
                            <div class="d-flex align-items-center text-nowrap">
                                Toplam {{filteredLength || 0}} kayıt arasından
                                <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                    <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                                </select>
                                gösteriliyor.
                            </div>
                        </div>
                        <div class="col-auto mb-1 mb-md-0">
                            <b-pagination class="mb-0" v-model="p" :total-rows="(filteredLength || 0)" :per-page="perPage"></b-pagination>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard,BInputGroupText, BInputGroup, BFormInput,BOverlay,BPagination,BDropdown,BDropdownItem } from 'bootstrap-vue';
import EmployeeOperationsApi from '@/api/employee-operations'
import Additional from '@/utilities/additional'

export default {
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:()=>({})
        },
    },
    components:{
        BCard,
        BInputGroupText, 
        BInputGroup, 
        BFormInput,
        BOverlay,
        BPagination,
        BDropdown,
        BDropdownItem
    },
    data(){
        return {
            searchValue:"",
            serverData:[],
            p:1,
            total:0,
            perPage:10,
            perPages:[10,20,30,40,50,100],
            filteredLength:0,
            excelPath:null,
            loading:false
        }
    },
    methods:{
        getData(data){
            this.loading = true
            this.excelPath = null
            EmployeeOperationsApi.Levy.PaymentTable({
                ...this.filter,
                PaginateRequest:{
                    ...data,
                    QueryParam:this.searchValue
                }
            }).then(res => {
                this.serverData = []
                this.loading = false
                if(res.data.Success){
                    this.total = (res.data.Data.Data || []).length
                    this.serverData = res.data.Data.Data || []
                    this.excelPath = res.data.Data.ExcelPath
                }else{
                    this.total = 0
                    this.serverData = []
                }
            }).catch(()=>{
                this.loading = false
                this.total = 0
                this.serverData = []
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    },
    computed:{
        c_items(){
            const data = this.serverData
                .filter(r => Additional.ToEng(r.EmployeeFullName).toLowerCase().includes(Additional.ToEng(this.searchValue).toLowerCase()))
            this.filteredLength = (data ||[]).length
            return data.slice((this.p-1)*this.perPage,this.p*this.perPage)
        },
    }
}
</script>